import { createGenericDispatcher } from './action-dispatcher-factory';

import { PersonClient } from '../api/person-api-client';

export const updatePerson = (personId: number, update: Record<string, any>) =>
  createGenericDispatcher({
    name: 'UPDATE_PERSON',
    loadFunction: () => new PersonClient(personId).update(update),
    args: { personId, update },
  });
